#import "./ConfirmationTokenDetails.graphql"
query ConfirmationTokenQuery($token: String!) {
  confirmationToken(token: $token) {
    ...confirmationTokenDetails
  }
}
